module.exports = {
  primary: "#38BDF8",
  secondary: "#0EA5E9",
  white: "#ffffff",
  gray50: "#f8fafc",
  gray100: "#f1f5f9",
  gray200: "#e2e8f0",
  gray300: "#cbd5e1",
  gray400: "#94a3b8",
  gray500: "#64748b",
  gray600: "#475569",
  gray700: "#334155",
  gray800: "#1e293b",
  gray900: "#0f172a",

  bad: "#EF4444",
  ok: "#A3E635",
  great: "#FACC15",
  amazing: "#38BDF8",
  superb: "#4ADE80",

  badBg: "linear-gradient(270deg, rgba(239, 68, 68, 0) 0%, rgba(239, 68, 68, 0.24) 100%)",
  okBg: "linear-gradient(270deg, rgba(163, 230, 53, 0) 0%, rgba(163, 230, 53, 0.24) 100%)",
  greatBg: "linear-gradient(270deg, rgba(250, 204, 21, 0) 0%, rgba(250, 204, 21, 0.24) 100%)",
  superbBg: "linear-gradient(270deg, rgba(74, 222, 128, 0) 0%, rgba(74, 222, 128, 0.24) 100%)",

  // bad: "linear-gradient(180deg, #F43F5E 0%, #881337 100%);",
  // ok: "linear-gradient(180deg, #96DC24 0%, #64A000 100%);",
  // great: "linear-gradient(180deg, #FACC15 0%, #F59E0B 100%);",
  // amazing: "linear-gradient(180deg, #22D3EE 0%, #0076AA 100%);",
  // superb: "linear-gradient(180deg, #4ADE80 0%, #029D3B 100%);",
}
